import React from 'react'
import { valueOrUndefined, markdown } from '../common'
import { Typography } from '../types'
import propTypeSchema from 'react-json-schema-proptypes'
import Radium from 'radium'

const TextStyleSchema = {
  'type': 'object',
  'properties': {
    'inside': Typography.Schema,
    'outside': Typography.Schema
  }
}

const schema = {
  'type': 'object',
  'required': ['title1'],
  'properties': {
    'type': {'enum': ['beta']},
    title1: {'type': 'string'},
    title1Style: TextStyleSchema,
    title2: {'type': 'string'},
    title2Style: TextStyleSchema,
    subtitle: {'type': 'string'},
    subtitleStyle: TextStyleSchema,
    smallMessage: {'type': 'string'},
    smallMessageStyle: TextStyleSchema,
    image: {'type': 'string'},
    middleImage: {'type': 'string'},
    mobileImageBreakpoint: {'type': 'number'},
    bgColor: {'type': 'string'},
    isShort: {'type': 'boolean'},
    separatorColor: {'type': 'string'}
  }
}

const defaultTextColor = '#fff'
const defaultDarkTextColor = '#000'

@Radium
export default class BetaHeader extends React.PureComponent {
  static propSchema = schema

  static propTypes = propTypeSchema(schema, {
    'properties': {
      assetLoader: {'isFunction': true}
    }
  })

  static defaultProps = {
    image: 'donate-banner.png',
    mobileImageBreakpoint: 992,
    bgColor: '#18191B',
    title1Style: {
      inside: {
        color: defaultTextColor
      },
      outside: {
        color: defaultDarkTextColor
      }
    },
    title2Style: {
      inside: {
        color: defaultTextColor
      },
      outside: {
        color: defaultDarkTextColor
      }
    },
    subtitleStyle: {
      inside: {
        color: defaultTextColor
      },
      outside: {
        color: defaultDarkTextColor
      }
    },
    smallMessageStyle: {
      inside: {
        color: defaultTextColor
      },
      outside: {
        color: defaultDarkTextColor
      }
    },
    separatorColor: '#46464B'
  }

  render () {

    const styles = {
      topBanner: {
        backgroundImage: `url(${this.props.assetLoader(this.props.image)})`,
        backgroundColor: this.props.bgColor
      },
      first: valueOrUndefined(this.props, 'title1Style.inside'),
      firstMiddle: valueOrUndefined(this.props, 'title1Style.outside'),
      second: valueOrUndefined(this.props, 'title2Style.inside'),
      secondMiddle: valueOrUndefined(this.props, 'title2Style.outside'),
      third: valueOrUndefined(this.props, 'subtitleStyle.inside'),
      thirdMiddle: valueOrUndefined(this.props, 'subtitleStyle.outside'),
      fourth: valueOrUndefined(this.props, 'smallMessageStyle.inside'),
      fourthMiddle: valueOrUndefined(this.props, 'smallMessageStyle.outside'),
      separator: {
        backgroundColor: this.props.separatorColor
      },
      customHidden: {
        main: {},
        middle: {}
      }
    }
    styles['customHidden']['main'][`@media (max-width: ${this.props.mobileImageBreakpoint - 1}px)`] = {
      display: 'none'
    }
    styles['customHidden']['middle'][`@media (min-width: ${this.props.mobileImageBreakpoint}px)`] = {
      display: 'none'
    }
    if (this.props.middleImage) {
      styles['topBanner'][`@media (min-width: ${this.props.mobileImageBreakpoint}px)`] = {
        backgroundImage: this.props.assetLoader(this.props.middleImage)
      }
    }
    return <div className='beta'>
      <div className={'topBanner' + (this.props.isShort ? ' short' : '')} style={[styles.topBanner]}>
        <div className='first' style={[styles.first, styles.customHidden.main]}>{this.props.title1}</div>
        <div className='second' style={[styles.second, styles.customHidden.main]}>{this.props.title2}</div>
        <div className='betaContainer'>
          <div className='third' style={[styles.third, styles.customHidden.main]}>{this.props.subtitle}</div>
          <div className='fourth' style={[styles.fourth, styles.customHidden.main]}>
            {markdown(this.props.smallMessage)}
          </div>
        </div>
      </div>
      <div className={'middleBanner'} style={[styles.customHidden.middle]}>
        <div className='first' style={[styles.firstMiddle, styles.customHidden.middle]}>{this.props.title1}</div>
        <div className='second' style={[styles.secondMiddle, styles.customHidden.middle]}>{this.props.title2}</div>
      </div>
      <div className='middleSeparatorOuter'>
        <div className='middleSeparator' style={[styles.separator, styles.customHidden.middle]}/>
      </div>
      <div className={'middleBanner'}>
        <div className='third' style={[styles.thirdMiddle, styles.customHidden.middle]}>{this.props.subtitle}</div>
        <div className='fourth' style={[styles.fourthMiddle, styles.customHidden.middle]}>
          {markdown(this.props.smallMessage)}
        </div>
      </div>
    </div>
  }
}
